import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '../common';

type Variables = {
  id: number;
  address?: string;
  startDatetime: string;
  endDatetime: string;
  deliveryAddress?: string;
  returnAddress?: string;
};
type Response = {
  isAvailable: boolean;
};

export const useCarAvailable = createQuery<Response, Variables, AxiosError>({
  queryKey: ['car/available'],
  fetcher: ({
    id,
    startDatetime,
    endDatetime,
    deliveryAddress,
    returnAddress,
  }) => {
    const params = new URLSearchParams();

    if (startDatetime) {
      params.append('start_datetime', startDatetime);
    }

    if (endDatetime) {
      params.append('end_datetime', endDatetime);
    }

    params.append('delivery_address', deliveryAddress || '');
    params.append('return_address', returnAddress || '');

    return client
      .get(`v2/cars/${id}/available?${params.toString()}`)
      .then((response) => {
        return response.data.data;
      })
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      });
  },
});
